<h2 mat-dialog-title>{{'advancedSettings' | translate}}</h2>

<mat-dialog-content style="width:480px;">
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >
      <form [formGroup]="passEditForm" class="m-1">
        <label class="mb-3 text-muted fs-6">{{'general' | translate}}</label>

        <mat-form-field appearance="outline" class="w-100 mb-3 ">
          <mat-label>{{'pass.name' | translate}}</mat-label>
          <input formControlName="name" type="text" matInput placeholder="{{'pass.name' | translate}}">
          <mat-icon matSuffix aria-hidden="false" matTooltip="{{'pass.payloadHint' | translate}}">info</mat-icon>
          <mat-hint>{{'pass.nameHint' | translate}}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100 mb-3">
          <mat-label>{{'pass.templateName' | translate}}</mat-label>
          <input formControlName="templateName" type="text" matInput placeholder="{{'pass.templateName' | translate}}">
          <mat-hint>{{'pass.templateNameHint' | translate}}</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline" class="w-100">
          <mat-label>{{'pass.comment' | translate}}</mat-label>
          <input formControlName="comment" type="text" matInput placeholder="{{'pass.comment' | translate}}">
        </mat-form-field>

        <!-- TODO: Unused option
        <div class="p-3 form-control mb-3 d-flex justify-content-between">
          <label for="value">{{'pass.enableShoppingCart' | translate}}</label>
          <mat-slide-toggle class="example-margin" formControlName="enableShoppingCart" ></mat-slide-toggle>
        </div> -->

        <div class="p-3 form-control mb-1 d-flex justify-content-between">
          <label for="value">{{'pass.enableCustomerLogin' | translate}}</label>
          <mat-slide-toggle class="example-margin" formControlName="enableCustomerLogin" ></mat-slide-toggle>
        </div>

        <div class="my-3">
          <div class="d-flex flex-row flex-wrap align-items-center">
            <label class="my-3 text-muted fs-6 text-uppercase" >{{'pass.languages' | translate}}</label>
          </div>
          <div class="form-group my-2">
            @if (languagesPass.length==0) {
              <div class="d-flex flex-row justify-content-between align-items-center flex-wrap">
                <p style="font-size:14px;color:var(--warmOrange);">{{'languages_hint' | translate}}</p>
              </div>
            }

            <mat-form-field appearance="outline" class="w-100 mb-3">
              <mat-label data-nar="dpp-settings-default-language">{{ 'defaultLanguage' | translate }}</mat-label>
              <mat-select [value]="languagesPass[0]" (selectionChange)="setDefaultLanguage($event.value)">
                @for (lang of languagesPass; track lang) {
                  <mat-option [value]="lang" data-nar="dpp-settings-default-language-option">
                    {{ languagesList[lang] }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            @if (defaultLanguageChanged) {
              <div class="warning mb-4">
                {{'pass.defaultLanguageChanged' | translate}}
              </div>
            }

            <mat-accordion>
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'pass.languageSelection' | translate}} ({{languagesPass.length}})
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="p-2">

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'search' | translate}}</mat-label>
                    <input matInput [formControl]="filterControl" placeholder="{{'search' | translate}}" inputmode="search" pattern="[a-zA-Z]+" />
                    <mat-icon matSuffix>search</mat-icon>
                  </mat-form-field>

                  <div class="multi-column-menu">
                    @for (lang of filteredLanguages; track lang) {
                      <div class="d-flex">
                        <mat-checkbox
                          [checked]="languagesPass.includes(lang[0])"
                          (change)="toggleLanguageOfPass(lang[0])"
                                            [disabled]="
                                                languagesPass.length === 1 && 
                                                languagesPass[0] === lang[0]
                                            ">
                          {{lang[1]}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

      </form>
    </section>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button style="color:var(--warmOrange);" (click)="onCancelEdit();" > {{'cancel' | translate}} </button>
  <button mat-button class="orange-button" [disabled]="!passEditForm.valid" (click)="onSaveEdit();" >{{'apply' | translate}}</button>
</mat-dialog-actions>